import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20golden%20and%20cream%20tones%2C%20smooth%20flowing%20shapes%2C%20elegant%20minimalist%20design%2C%20luxurious%20atmosphere%2C%20abstract%20artistic%20composition%20with%20organic%20curves&width=1600&height=600&seq=jmtt-cta-bg&orientation=landscape"
        alt="加入JMTT"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/85 to-foreground-900/60"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3">
          准备好加入 JMTT 了吗？
        </h2>
        <p className="text-white/60 text-sm md:text-base max-w-lg mx-auto mb-8">
          立即注册JMTT，开启高效数字化之旅。新用户可享14天免费试用，无需绑定任何支付方式。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            免费注册
          </Link>
          <Link
            to="/categories?cat=tutorial"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-medium text-sm rounded-lg border border-white/25 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            查看教程
          </Link>
        </div>
      </div>
    </section>
  );
}